// *** AUTO-GENERATED by scripts/generate-piezo-endpoints.ts — do not edit ***
// Generated at: 2026-11-04T13:20:43.774Z
/**
 * Piezo service endpoints indexed by [stage][authType][region].
 * Generated from RIP data at build time — no runtime native dependencies.
 */
export const PIEZO_ENDPOINTS = {
    "gamma": {
        "iam": {
            "ap-southeast-6": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.akl.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.akl.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.akl.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.akl.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.akl.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.akl.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.akl.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.akl.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.akl.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.akl.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "us-isof-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://i-issuer-casc-a.ale.gamma.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://i-issuer-casc-b.ale.gamma.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://i-issuer-casc-c.ale.gamma.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://i-issuer-alps-c.ale.gamma.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://i-issuer-alps-a.ale.gamma.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://i-issuer-alps-b.ale.gamma.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.ale.gamma.notary-piezo.a2z.hci.ic.gov",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.ale.gamma.notary-piezo.a2z.hci.ic.gov",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.ale.gamma.notary-piezo.a2z.hci.ic.gov",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.ale.gamma.notary-piezo.a2z.hci.ic.gov",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "eu-north-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.arn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.arn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.arn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.arn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.arn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.arn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.arn.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.arn.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.arn.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.arn.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-southeast-7": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.bkk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.bkk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.bkk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.bkk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.bkk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.bkk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.bkk.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.bkk.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.bkk.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.bkk.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.bom.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.bom.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.bom.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.bom.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.bom.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.bom.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.bom.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.bom.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.bom.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.bom.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "eu-west-3": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.cdg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.cdg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.cdg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.cdg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.cdg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.cdg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.cdg.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.cdg.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.cdg.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.cdg.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-southeast-3": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.cgk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.cgk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.cgk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.cgk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.cgk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.cgk.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.cgk.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.cgk.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.cgk.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.cgk.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "us-east-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.cmh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.cmh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.cmh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.cmh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.cmh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.cmh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.cmh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.cmh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.cmh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.cmh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "af-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.cpt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.cpt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.cpt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.cpt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.cpt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.cpt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.cpt.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.cpt.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.cpt.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.cpt.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "eu-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.dub.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.dub.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.dub.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.dub.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.dub.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.dub.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.dub.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.dub.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.dub.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.dub.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "eu-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.fra.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.fra.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.fra.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.fra.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.fra.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.fra.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.fra.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.fra.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.fra.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.fra.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "sa-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.gru.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.gru.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.gru.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.gru.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.gru.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.gru.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.gru.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.gru.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.gru.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.gru.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.hkg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.hkg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.hkg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.hkg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.hkg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.hkg.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.hkg.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.hkg.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.hkg.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.hkg.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-south-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.hyd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.hyd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.hyd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.hyd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.hyd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.hyd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.hyd.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.hyd.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.hyd.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.hyd.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "us-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.iad.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.iad.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.iad.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.iad.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.iad.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.iad.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.iad.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.iad.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.iad.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.iad.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-northeast-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.icn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.icn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.icn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.icn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.icn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.icn.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.icn.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.icn.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.icn.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.icn.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-northeast-3": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.kix.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.kix.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.kix.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.kix.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.kix.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.kix.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.kix.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.kix.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.kix.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.kix.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-southeast-5": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.kul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.kul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.kul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.kul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.kul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.kul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.kul.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.kul.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.kul.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.kul.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "eu-west-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.lhr.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.lhr.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.lhr.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.lhr.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.lhr.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.lhr.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.lhr.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.lhr.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.lhr.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.lhr.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "us-northeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.mdw.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.mdw.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.mdw.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.mdw.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.mdw.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.mdw.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.mdw.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.mdw.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.mdw.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.mdw.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-southeast-4": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.mel.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.mel.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.mel.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.mel.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.mel.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.mel.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.mel.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.mel.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.mel.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.mel.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "eu-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.mxp.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.mxp.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.mxp.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.mxp.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.mxp.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.mxp.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.mxp.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.mxp.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.mxp.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.mxp.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "eu-isoe-west-1": {
                "okapiIssuers": [],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.ncl.gamma.notary-piezo.a2z.adc-e.uk",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.ncl.gamma.notary-piezo.a2z.adc-e.uk",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.ncl.gamma.notary-piezo.a2z.adc-e.uk",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.ncl.gamma.notary-piezo.a2z.adc-e.uk",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-northeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.nrt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.nrt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.nrt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.nrt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.nrt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.nrt.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.nrt.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.nrt.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.nrt.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.nrt.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "us-gov-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://i-issuer-casc-a.osu.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://i-issuer-casc-b.osu.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://i-issuer-casc-c.osu.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://i-issuer-alps-c.osu.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://i-issuer-alps-a.osu.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://i-issuer-alps-b.osu.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.osu.gamma.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.osu.gamma.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.osu.gamma.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.osu.gamma.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "us-gov-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://i-issuer-casc-a.pdt.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://i-issuer-casc-b.pdt.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://i-issuer-casc-c.pdt.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://i-issuer-alps-c.pdt.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://i-issuer-alps-a.pdt.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://i-issuer-alps-b.pdt.gamma.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.pdt.gamma.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.pdt.gamma.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.pdt.gamma.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.pdt.gamma.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "us-west-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.pdx.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.pdx.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.pdx.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.pdx.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.pdx.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.pdx.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.pdx.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.pdx.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.pdx.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.pdx.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "mx-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.qro.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.qro.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.qro.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.qro.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.qro.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.qro.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.qro.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.qro.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.qro.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.qro.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "me-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.ruh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.ruh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.ruh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.ruh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.ruh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.ruh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.ruh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.ruh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.ruh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.ruh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "us-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.sfo.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.sfo.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.sfo.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.sfo.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.sfo.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.sfo.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.sfo.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.sfo.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.sfo.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.sfo.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-southeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.sin.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.sin.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.sin.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.sin.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.sin.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.sin.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.sin.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.sin.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.sin.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.sin.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-southeast-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.syd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.syd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.syd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.syd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.syd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.syd.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.syd.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.syd.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.syd.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.syd.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "eusc-de-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.thf.gamma.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.thf.gamma.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.thf.gamma.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.thf.gamma.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.thf.gamma.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.thf.gamma.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.thf.gamma.notary-piezo.aws.a2z.eu",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.thf.gamma.notary-piezo.aws.a2z.eu",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.thf.gamma.notary-piezo.aws.a2z.eu",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.thf.gamma.notary-piezo.aws.a2z.eu",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "il-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.tlv.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.tlv.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.tlv.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.tlv.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.tlv.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.tlv.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.tlv.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.tlv.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.tlv.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.tlv.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ap-east-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.tpe.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.tpe.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.tpe.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.tpe.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.tpe.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.tpe.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.tpe.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.tpe.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.tpe.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.tpe.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ca-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.yul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.yul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.yul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.yul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.yul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.yul.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.yul.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.yul.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.yul.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.yul.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "ca-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.yyc.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.yyc.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.yyc.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.yyc.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.yyc.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.yyc.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.yyc.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.yyc.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.yyc.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.yyc.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "eu-south-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.zaz.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.zaz.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.zaz.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.zaz.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.zaz.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.zaz.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.zaz.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.zaz.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.zaz.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.zaz.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            },
            "eu-central-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-a.zrh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-b.zrh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.zrh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.zrh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.zrh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.zrh.gamma.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.iam.zrh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    },
                    {
                        "url": "https://clerk-cascades-b.iam.zrh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.zrh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.zrh.gamma.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    }
                ]
            }
        },
        "midway": {
            "ap-southeast-6": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.akl.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.akl.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.akl.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.akl.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.akl.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.akl.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.akl.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.akl.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.akl.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.akl.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-isof-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://m-issuer-casc-a.ale.gamma.okapi-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://m-issuer-alps-a.ale.gamma.okapi-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://m-issuer-alps-b.ale.gamma.okapi-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://m-issuer-alps-c.ale.gamma.okapi-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://m-issuer-casc-b.ale.gamma.okapi-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://m-issuer-casc-c.ale.gamma.okapi-piezo.a2z.hci.ic.gov"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.ale.gamma.notary-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.ale.gamma.notary-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.ale.gamma.notary-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.ale.gamma.notary-piezo.a2z.hci.ic.gov"
                    }
                ]
            },
            "eu-north-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.arn.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.arn.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.arn.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.arn.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.arn.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.arn.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.arn.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.arn.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.arn.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.arn.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-7": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.bkk.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.bkk.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.bkk.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.bkk.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.bkk.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.bkk.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.bkk.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.bkk.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.bkk.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.bkk.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.bom.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.bom.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.bom.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.bom.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.bom.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.bom.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.bom.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.bom.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.bom.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.bom.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-west-3": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.cdg.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.cdg.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.cdg.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.cdg.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.cdg.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.cdg.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.cdg.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.cdg.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.cdg.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.cdg.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-3": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.cgk.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.cgk.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.cgk.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.cgk.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.cgk.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.cgk.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.cgk.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.cgk.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.cgk.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.cgk.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-east-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.cmh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.cmh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.cmh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.cmh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.cmh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.cmh.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.cmh.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.cmh.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.cmh.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.cmh.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "af-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.cpt.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.cpt.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.cpt.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.cpt.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.cpt.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.cpt.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.cpt.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.cpt.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.cpt.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.cpt.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.dub.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.dub.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.dub.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.dub.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.dub.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.dub.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.dub.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.dub.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.dub.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.dub.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.fra.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.fra.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.fra.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.fra.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.fra.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.fra.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.fra.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.fra.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.fra.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.fra.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "sa-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.gru.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.gru.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.gru.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.gru.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.gru.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.gru.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.gru.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.gru.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.gru.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.gru.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.hkg.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.hkg.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.hkg.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.hkg.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.hkg.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.hkg.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.hkg.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.hkg.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.hkg.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.hkg.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-south-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.hyd.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.hyd.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.hyd.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.hyd.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.hyd.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.hyd.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.hyd.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.hyd.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.hyd.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.hyd.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.iad.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.iad.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.iad.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.iad.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.iad.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.iad.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.iad.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.iad.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.iad.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.iad.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-northeast-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.icn.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.icn.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.icn.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.icn.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.icn.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.icn.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.icn.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.icn.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.icn.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.icn.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-northeast-3": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.kix.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.kix.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.kix.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.kix.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.kix.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.kix.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.kix.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.kix.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.kix.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.kix.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-5": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.kul.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.kul.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.kul.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.kul.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.kul.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.kul.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.kul.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.kul.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.kul.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.kul.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-west-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.lhr.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.lhr.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.lhr.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.lhr.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.lhr.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.lhr.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.lhr.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.lhr.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.lhr.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.lhr.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-northeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.mdw.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.mdw.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.mdw.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.mdw.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.mdw.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.mdw.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.mdw.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.mdw.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.mdw.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.mdw.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-4": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.mel.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.mel.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.mel.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.mel.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.mel.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.mel.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.mel.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.mel.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.mel.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.mel.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.mxp.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.mxp.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.mxp.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.mxp.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.mxp.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.mxp.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.mxp.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.mxp.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.mxp.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.mxp.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-isoe-west-1": {
                "okapiIssuers": [],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.ncl.gamma.notary-piezo.a2z.adc-e.uk"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.ncl.gamma.notary-piezo.a2z.adc-e.uk"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.ncl.gamma.notary-piezo.a2z.adc-e.uk"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.ncl.gamma.notary-piezo.a2z.adc-e.uk"
                    }
                ]
            },
            "ap-northeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.nrt.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.nrt.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.nrt.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.nrt.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.nrt.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.nrt.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.nrt.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.nrt.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.nrt.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.nrt.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-gov-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://m-issuer-casc-a.osu.gamma.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-alps-a.osu.gamma.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-alps-b.osu.gamma.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-alps-c.osu.gamma.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-casc-b.osu.gamma.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-casc-c.osu.gamma.gov.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.osu.gamma.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.osu.gamma.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.osu.gamma.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.osu.gamma.gov.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-gov-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://m-issuer-casc-a.pdt.gamma.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-alps-a.pdt.gamma.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-alps-b.pdt.gamma.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-alps-c.pdt.gamma.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-casc-b.pdt.gamma.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-casc-c.pdt.gamma.gov.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.pdt.gamma.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.pdt.gamma.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.pdt.gamma.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.pdt.gamma.gov.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-west-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.pdx.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.pdx.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.pdx.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.pdx.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.pdx.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.pdx.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.pdx.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.pdx.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.pdx.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.pdx.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "mx-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.qro.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.qro.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.qro.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.qro.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.qro.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.qro.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.qro.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.qro.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.qro.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.qro.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "me-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.ruh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.ruh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.ruh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.ruh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.ruh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.ruh.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.ruh.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.ruh.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.ruh.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.ruh.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.sfo.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.sfo.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.sfo.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.sfo.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.sfo.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.sfo.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.sfo.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.sfo.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.sfo.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.sfo.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.sin.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.sin.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.sin.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.sin.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.sin.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.sin.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.sin.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.sin.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.sin.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.sin.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.syd.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.syd.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.syd.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.syd.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.syd.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.syd.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.syd.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.syd.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.syd.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.syd.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "eusc-de-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.thf.gamma.okapi-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.thf.gamma.okapi-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.thf.gamma.okapi-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.thf.gamma.okapi-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.thf.gamma.okapi-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.thf.gamma.okapi-piezo.aws.a2z.eu"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.thf.gamma.notary-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.thf.gamma.notary-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.thf.gamma.notary-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.thf.gamma.notary-piezo.aws.a2z.eu"
                    }
                ]
            },
            "il-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.tlv.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.tlv.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.tlv.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.tlv.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.tlv.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.tlv.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.tlv.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.tlv.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.tlv.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.tlv.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-east-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.tpe.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.tpe.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.tpe.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.tpe.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.tpe.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.tpe.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.tpe.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.tpe.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.tpe.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.tpe.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ca-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.yul.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.yul.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.yul.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.yul.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.yul.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.yul.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.yul.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.yul.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.yul.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.yul.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "ca-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.yyc.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.yyc.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.yyc.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.yyc.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.yyc.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.yyc.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.yyc.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.yyc.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.yyc.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.yyc.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-south-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.zaz.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.zaz.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.zaz.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.zaz.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.zaz.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.zaz.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.zaz.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.zaz.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.zaz.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.zaz.gamma.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-central-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-cascades-a.zrh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.zrh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.zrh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-c.zrh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.zrh.gamma.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.zrh.gamma.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-a.midway.zrh.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.zrh.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-b.midway.zrh.gamma.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.zrh.gamma.notary.piezo.aws.dev"
                    }
                ]
            }
        }
    },
    "prod": {
        "iam": {
            "ap-southeast-6": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.akl.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.akl.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.akl.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.akl.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.akl.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.akl.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.akl.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.akl.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.akl.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.akl.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "us-isof-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://i-issuer-casc-b.ale.prod.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://i-issuer-alps-b.ale.prod.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://i-issuer-casc-c.ale.prod.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://i-issuer-alps-a.ale.prod.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://i-issuer-casc-a.ale.prod.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://i-issuer-alps-c.ale.prod.okapi-piezo.a2z.hci.ic.gov",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.ale.prod.notary-piezo.a2z.hci.ic.gov",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.ale.prod.notary-piezo.a2z.hci.ic.gov",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.ale.prod.notary-piezo.a2z.hci.ic.gov",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.ale.prod.notary-piezo.a2z.hci.ic.gov",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "eu-north-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.arn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.arn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.arn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.arn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.arn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.arn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.arn.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.arn.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.arn.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.arn.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-southeast-7": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.bkk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.bkk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.bkk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.bkk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.bkk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.bkk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.bkk.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.bkk.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.bkk.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.bkk.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.bom.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.bom.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.bom.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.bom.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.bom.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.bom.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.bom.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.bom.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.bom.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.bom.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "eu-west-3": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.cdg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.cdg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.cdg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.cdg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.cdg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.cdg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.cdg.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.cdg.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.cdg.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.cdg.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-southeast-3": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.cgk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.cgk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.cgk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.cgk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.cgk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.cgk.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.cgk.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.cgk.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.cgk.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.cgk.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "us-east-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.cmh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.cmh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.cmh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.cmh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.cmh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.cmh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.cmh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.cmh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.cmh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.cmh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "af-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.cpt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.cpt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.cpt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.cpt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.cpt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.cpt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.cpt.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.cpt.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.cpt.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.cpt.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "eu-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.dub.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.dub.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.dub.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.dub.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.dub.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.dub.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.dub.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.dub.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.dub.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.dub.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "eu-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.fra.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.fra.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.fra.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.fra.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.fra.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.fra.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.fra.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.fra.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.fra.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.fra.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "sa-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.gru.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.gru.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.gru.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.gru.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.gru.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.gru.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.gru.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.gru.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.gru.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.gru.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.hkg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.hkg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.hkg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.hkg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.hkg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.hkg.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.hkg.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.hkg.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.hkg.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.hkg.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-south-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.hyd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.hyd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.hyd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.hyd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.hyd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.hyd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.hyd.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.hyd.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.hyd.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.hyd.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "us-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.iad.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.iad.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.iad.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.iad.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.iad.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.iad.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.iad.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.iad.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.iad.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.iad.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-northeast-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.icn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.icn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.icn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.icn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.icn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.icn.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.icn.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.icn.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.icn.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.icn.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-northeast-3": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.kix.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.kix.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.kix.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.kix.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.kix.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.kix.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.kix.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.kix.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.kix.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.kix.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-southeast-5": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.kul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.kul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.kul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.kul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.kul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.kul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.kul.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.kul.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.kul.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.kul.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "eu-west-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.lhr.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.lhr.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.lhr.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.lhr.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.lhr.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.lhr.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.lhr.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.lhr.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.lhr.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.lhr.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "us-northeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.mdw.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.mdw.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.mdw.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.mdw.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.mdw.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.mdw.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.mdw.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.mdw.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.mdw.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.mdw.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-southeast-4": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.mel.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.mel.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.mel.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.mel.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.mel.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.mel.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.mel.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.mel.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.mel.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.mel.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "eu-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.mxp.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.mxp.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.mxp.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.mxp.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.mxp.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.mxp.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.mxp.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.mxp.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.mxp.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.mxp.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "eu-isoe-west-1": {
                "okapiIssuers": [],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.ncl.prod.notary-piezo.a2z.adc-e.uk",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.ncl.prod.notary-piezo.a2z.adc-e.uk",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.ncl.prod.notary-piezo.a2z.adc-e.uk",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.ncl.prod.notary-piezo.a2z.adc-e.uk",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-northeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.nrt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.nrt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.nrt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.nrt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.nrt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.nrt.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.nrt.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.nrt.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.nrt.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.nrt.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "us-gov-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://i-issuer-casc-b.osu.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://i-issuer-alps-b.osu.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://i-issuer-casc-c.osu.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://i-issuer-alps-a.osu.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://i-issuer-casc-a.osu.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://i-issuer-alps-c.osu.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.osu.prod.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.osu.prod.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.osu.prod.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.osu.prod.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "us-gov-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://i-issuer-casc-b.pdt.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://i-issuer-alps-b.pdt.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://i-issuer-casc-c.pdt.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://i-issuer-alps-a.pdt.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://i-issuer-casc-a.pdt.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://i-issuer-alps-c.pdt.prod.gov.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.pdt.prod.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.pdt.prod.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.pdt.prod.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.pdt.prod.gov.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "us-west-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.pdx.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.pdx.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.pdx.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.pdx.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.pdx.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.pdx.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.pdx.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.pdx.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.pdx.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.pdx.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "mx-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.qro.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.qro.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.qro.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.qro.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.qro.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.qro.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.qro.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.qro.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.qro.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.qro.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "me-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.ruh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.ruh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.ruh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.ruh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.ruh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.ruh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.ruh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.ruh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.ruh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.ruh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "us-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.sfo.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.sfo.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.sfo.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.sfo.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.sfo.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.sfo.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.sfo.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.sfo.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.sfo.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.sfo.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-southeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.sin.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.sin.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.sin.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.sin.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.sin.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.sin.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.sin.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.sin.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.sin.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.sin.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-southeast-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.syd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.syd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.syd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.syd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.syd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.syd.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.syd.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.syd.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.syd.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.syd.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "eusc-de-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.thf.prod.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.thf.prod.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.thf.prod.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.thf.prod.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.thf.prod.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.thf.prod.okapi-piezo.aws.a2z.eu",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.thf.prod.notary-piezo.aws.a2z.eu",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.thf.prod.notary-piezo.aws.a2z.eu",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.thf.prod.notary-piezo.aws.a2z.eu",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.thf.prod.notary-piezo.aws.a2z.eu",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "il-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.tlv.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.tlv.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.tlv.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.tlv.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.tlv.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.tlv.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.tlv.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.tlv.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.tlv.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.tlv.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ap-east-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.tpe.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.tpe.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.tpe.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.tpe.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.tpe.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.tpe.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.tpe.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.tpe.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.tpe.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.tpe.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ca-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.yul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.yul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.yul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.yul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.yul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.yul.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.yul.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.yul.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.yul.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.yul.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "ca-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.yyc.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.yyc.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.yyc.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.yyc.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.yyc.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.yyc.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.yyc.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.yyc.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.yyc.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.yyc.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "eu-south-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.zaz.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.zaz.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.zaz.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.zaz.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.zaz.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.zaz.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.zaz.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.zaz.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.zaz.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.zaz.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            },
            "eu-central-2": {
                "okapiIssuers": [
                    {
                        "url": "https://iam-issuer-cascades-b.zrh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-b"
                    },
                    {
                        "url": "https://iam-issuer-alps-b.zrh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-b"
                    },
                    {
                        "url": "https://iam-issuer-cascades-c.zrh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-c"
                    },
                    {
                        "url": "https://iam-issuer-alps-a.zrh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-a"
                    },
                    {
                        "url": "https://iam-issuer-cascades-a.zrh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-cascades-a"
                    },
                    {
                        "url": "https://iam-issuer-alps-c.zrh.prod.okapi.piezo.aws.dev",
                        "signingName": "issuer-alps-c"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-cascades-b.iam.zrh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-b"
                    },
                    {
                        "url": "https://clerk-alps-b.iam.zrh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-b"
                    },
                    {
                        "url": "https://clerk-alps-a.iam.zrh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-alps-a"
                    },
                    {
                        "url": "https://clerk-cascades-a.iam.zrh.prod.notary.piezo.aws.dev",
                        "signingName": "clerk-cascades-a"
                    }
                ]
            }
        },
        "midway": {
            "ap-southeast-6": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.akl.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.akl.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.akl.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.akl.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.akl.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.akl.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.akl.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.akl.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.akl.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.akl.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-isof-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://m-issuer-alps-c.ale.prod.okapi-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://m-issuer-alps-b.ale.prod.okapi-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://m-issuer-alps-a.ale.prod.okapi-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://m-issuer-casc-a.ale.prod.okapi-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://m-issuer-casc-b.ale.prod.okapi-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://m-issuer-casc-c.ale.prod.okapi-piezo.a2z.hci.ic.gov"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.ale.prod.notary-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.ale.prod.notary-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.ale.prod.notary-piezo.a2z.hci.ic.gov"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.ale.prod.notary-piezo.a2z.hci.ic.gov"
                    }
                ]
            },
            "eu-north-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.arn.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.arn.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.arn.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.arn.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.arn.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.arn.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.arn.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.arn.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.arn.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.arn.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-7": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.bkk.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.bkk.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.bkk.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.bkk.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.bkk.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.bkk.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.bkk.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.bkk.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.bkk.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.bkk.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.bom.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.bom.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.bom.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.bom.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.bom.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.bom.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.bom.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.bom.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.bom.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.bom.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-west-3": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.cdg.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.cdg.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.cdg.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.cdg.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.cdg.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.cdg.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.cdg.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.cdg.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.cdg.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.cdg.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-3": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.cgk.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.cgk.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.cgk.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.cgk.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.cgk.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.cgk.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.cgk.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.cgk.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.cgk.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.cgk.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-east-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.cmh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.cmh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.cmh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.cmh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.cmh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.cmh.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.cmh.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.cmh.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.cmh.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.cmh.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "af-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.cpt.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.cpt.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.cpt.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.cpt.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.cpt.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.cpt.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.cpt.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.cpt.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.cpt.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.cpt.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.dub.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.dub.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.dub.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.dub.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.dub.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.dub.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.dub.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.dub.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.dub.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.dub.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.fra.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.fra.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.fra.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.fra.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.fra.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.fra.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.fra.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.fra.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.fra.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.fra.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "sa-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.gru.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.gru.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.gru.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.gru.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.gru.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.gru.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.gru.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.gru.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.gru.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.gru.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.hkg.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.hkg.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.hkg.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.hkg.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.hkg.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.hkg.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.hkg.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.hkg.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.hkg.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.hkg.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-south-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.hyd.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.hyd.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.hyd.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.hyd.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.hyd.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.hyd.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.hyd.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.hyd.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.hyd.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.hyd.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.iad.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.iad.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.iad.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.iad.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.iad.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.iad.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.iad.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.iad.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.iad.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.iad.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-northeast-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.icn.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.icn.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.icn.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.icn.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.icn.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.icn.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.icn.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.icn.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.icn.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.icn.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-northeast-3": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.kix.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.kix.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.kix.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.kix.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.kix.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.kix.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.kix.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.kix.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.kix.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.kix.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-5": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.kul.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.kul.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.kul.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.kul.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.kul.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.kul.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.kul.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.kul.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.kul.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.kul.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-west-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.lhr.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.lhr.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.lhr.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.lhr.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.lhr.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.lhr.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.lhr.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.lhr.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.lhr.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.lhr.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-northeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.mdw.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.mdw.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.mdw.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.mdw.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.mdw.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.mdw.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.mdw.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.mdw.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.mdw.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.mdw.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-4": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.mel.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.mel.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.mel.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.mel.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.mel.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.mel.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.mel.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.mel.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.mel.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.mel.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-south-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.mxp.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.mxp.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.mxp.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.mxp.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.mxp.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.mxp.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.mxp.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.mxp.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.mxp.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.mxp.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-isoe-west-1": {
                "okapiIssuers": [],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.ncl.prod.notary-piezo.a2z.adc-e.uk"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.ncl.prod.notary-piezo.a2z.adc-e.uk"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.ncl.prod.notary-piezo.a2z.adc-e.uk"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.ncl.prod.notary-piezo.a2z.adc-e.uk"
                    }
                ]
            },
            "ap-northeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.nrt.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.nrt.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.nrt.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.nrt.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.nrt.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.nrt.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.nrt.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.nrt.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.nrt.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.nrt.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-gov-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://m-issuer-alps-c.osu.prod.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-alps-b.osu.prod.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-alps-a.osu.prod.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-casc-a.osu.prod.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-casc-b.osu.prod.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-casc-c.osu.prod.gov.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.osu.prod.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.osu.prod.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.osu.prod.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.osu.prod.gov.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-gov-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://m-issuer-alps-c.pdt.prod.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-alps-b.pdt.prod.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-alps-a.pdt.prod.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-casc-a.pdt.prod.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-casc-b.pdt.prod.gov.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://m-issuer-casc-c.pdt.prod.gov.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.pdt.prod.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.pdt.prod.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.pdt.prod.gov.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.pdt.prod.gov.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-west-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.pdx.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.pdx.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.pdx.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.pdx.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.pdx.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.pdx.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.pdx.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.pdx.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.pdx.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.pdx.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "mx-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.qro.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.qro.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.qro.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.qro.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.qro.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.qro.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.qro.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.qro.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.qro.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.qro.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "me-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.ruh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.ruh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.ruh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.ruh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.ruh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.ruh.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.ruh.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.ruh.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.ruh.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.ruh.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "us-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.sfo.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.sfo.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.sfo.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.sfo.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.sfo.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.sfo.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.sfo.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.sfo.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.sfo.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.sfo.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.sin.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.sin.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.sin.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.sin.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.sin.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.sin.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.sin.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.sin.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.sin.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.sin.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-southeast-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.syd.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.syd.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.syd.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.syd.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.syd.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.syd.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.syd.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.syd.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.syd.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.syd.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "eusc-de-east-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.thf.prod.okapi-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.thf.prod.okapi-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.thf.prod.okapi-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.thf.prod.okapi-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.thf.prod.okapi-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.thf.prod.okapi-piezo.aws.a2z.eu"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.thf.prod.notary-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.thf.prod.notary-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.thf.prod.notary-piezo.aws.a2z.eu"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.thf.prod.notary-piezo.aws.a2z.eu"
                    }
                ]
            },
            "il-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.tlv.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.tlv.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.tlv.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.tlv.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.tlv.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.tlv.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.tlv.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.tlv.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.tlv.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.tlv.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ap-east-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.tpe.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.tpe.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.tpe.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.tpe.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.tpe.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.tpe.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.tpe.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.tpe.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.tpe.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.tpe.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ca-central-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.yul.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.yul.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.yul.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.yul.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.yul.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.yul.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.yul.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.yul.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.yul.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.yul.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "ca-west-1": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.yyc.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.yyc.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.yyc.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.yyc.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.yyc.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.yyc.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.yyc.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.yyc.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.yyc.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.yyc.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-south-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.zaz.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.zaz.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.zaz.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.zaz.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.zaz.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.zaz.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.zaz.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.zaz.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.zaz.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.zaz.prod.notary.piezo.aws.dev"
                    }
                ]
            },
            "eu-central-2": {
                "okapiIssuers": [
                    {
                        "url": "https://midway-issuer-alps-c.zrh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-b.zrh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-alps-a.zrh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-a.zrh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-b.zrh.prod.okapi.piezo.aws.dev"
                    },
                    {
                        "url": "https://midway-issuer-cascades-c.zrh.prod.okapi.piezo.aws.dev"
                    }
                ],
                "notaryClerks": [
                    {
                        "url": "https://clerk-alps-b.midway.zrh.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-alps-a.midway.zrh.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-a.midway.zrh.prod.notary.piezo.aws.dev"
                    },
                    {
                        "url": "https://clerk-cascades-b.midway.zrh.prod.notary.piezo.aws.dev"
                    }
                ]
            }
        }
    }
};
/**
 * Witness endpoints indexed by [stage][authType][partition][region].
 * Generated from RIP data at build time — no runtime native dependencies.
 */
export const WITNESS_ENDPOINTS = {
    "gamma": {
        "iam": {
            "aws-iso-f": {
                "us-isof-south-1": [
                    {
                        "url": "https://iam.ale.gamma.witness-piezo.a2z.hci.ic.gov",
                        "signingName": "piezo-witness"
                    }
                ]
            },
            "aws": {
                "eu-west-3": [
                    {
                        "url": "https://iam.cdg.gamma.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "us-east-2": [
                    {
                        "url": "https://iam.cmh.gamma.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "eu-central-1": [
                    {
                        "url": "https://iam.fra.gamma.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "us-east-1": [
                    {
                        "url": "https://iam.iad.gamma.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "us-northeast-1": [
                    {
                        "url": "https://iam.mdw.gamma.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "ap-northeast-1": [
                    {
                        "url": "https://iam.nrt.gamma.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "us-west-2": [
                    {
                        "url": "https://iam.pdx.gamma.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ]
            },
            "aws-us-gov": {
                "us-gov-east-1": [
                    {
                        "url": "https://iam.osu.gamma.gov.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "us-gov-west-1": [
                    {
                        "url": "https://iam.pdt.gamma.gov.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ]
            },
            "aws-eusc": {
                "eusc-de-east-1": [
                    {
                        "url": "https://iam.thf.gamma.witness-piezo.aws.a2z.eu",
                        "signingName": "piezo-witness"
                    }
                ]
            }
        },
        "midway": {
            "aws-iso-f": {
                "us-isof-south-1": [
                    {
                        "url": "https://midway.ale.gamma.witness-piezo.a2z.hci.ic.gov"
                    }
                ]
            },
            "aws": {
                "eu-west-3": [
                    {
                        "url": "https://midway.cdg.gamma.witness.piezo.aws.dev"
                    }
                ],
                "us-east-2": [
                    {
                        "url": "https://midway.cmh.gamma.witness.piezo.aws.dev"
                    }
                ],
                "eu-central-1": [
                    {
                        "url": "https://midway.fra.gamma.witness.piezo.aws.dev"
                    }
                ],
                "us-east-1": [
                    {
                        "url": "https://midway.iad.gamma.witness.piezo.aws.dev"
                    }
                ],
                "us-northeast-1": [
                    {
                        "url": "https://midway.mdw.gamma.witness.piezo.aws.dev"
                    }
                ],
                "ap-northeast-1": [
                    {
                        "url": "https://midway.nrt.gamma.witness.piezo.aws.dev"
                    }
                ],
                "us-west-2": [
                    {
                        "url": "https://midway.pdx.gamma.witness.piezo.aws.dev"
                    }
                ]
            },
            "aws-us-gov": {
                "us-gov-east-1": [
                    {
                        "url": "https://midway.osu.gamma.gov.witness.piezo.aws.dev"
                    }
                ],
                "us-gov-west-1": [
                    {
                        "url": "https://midway.pdt.gamma.gov.witness.piezo.aws.dev"
                    }
                ]
            },
            "aws-eusc": {
                "eusc-de-east-1": [
                    {
                        "url": "https://midway.thf.gamma.witness-piezo.aws.a2z.eu"
                    }
                ]
            }
        }
    },
    "prod": {
        "iam": {
            "aws-iso-f": {
                "us-isof-south-1": [
                    {
                        "url": "https://iam.ale.prod.witness-piezo.a2z.hci.ic.gov",
                        "signingName": "piezo-witness"
                    }
                ]
            },
            "aws": {
                "eu-west-3": [
                    {
                        "url": "https://iam.cdg.prod.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "us-east-2": [
                    {
                        "url": "https://iam.cmh.prod.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "eu-central-1": [
                    {
                        "url": "https://iam.fra.prod.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "us-east-1": [
                    {
                        "url": "https://iam.iad.prod.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "us-northeast-1": [
                    {
                        "url": "https://iam.mdw.prod.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "ap-northeast-1": [
                    {
                        "url": "https://iam.nrt.prod.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "us-west-2": [
                    {
                        "url": "https://iam.pdx.prod.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ]
            },
            "aws-us-gov": {
                "us-gov-east-1": [
                    {
                        "url": "https://iam.osu.prod.gov.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ],
                "us-gov-west-1": [
                    {
                        "url": "https://iam.pdt.prod.gov.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ]
            },
            "aws-eusc": {
                "eusc-de-east-1": [
                    {
                        "url": "https://iam.thf.prod.witness-piezo.aws.a2z.eu",
                        "signingName": "piezo-witness"
                    }
                ]
            }
        },
        "midway": {
            "aws-iso-f": {
                "us-isof-south-1": [
                    {
                        "url": "https://midway.ale.prod.witness-piezo.a2z.hci.ic.gov"
                    }
                ]
            },
            "aws": {
                "eu-west-3": [
                    {
                        "url": "https://midway.cdg.prod.witness.piezo.aws.dev"
                    }
                ],
                "us-east-2": [
                    {
                        "url": "https://midway.cmh.prod.witness.piezo.aws.dev"
                    }
                ],
                "eu-central-1": [
                    {
                        "url": "https://midway.fra.prod.witness.piezo.aws.dev"
                    }
                ],
                "us-east-1": [
                    {
                        "url": "https://midway.iad.prod.witness.piezo.aws.dev"
                    }
                ],
                "us-northeast-1": [
                    {
                        "url": "https://midway.mdw.prod.witness.piezo.aws.dev"
                    }
                ],
                "ap-northeast-1": [
                    {
                        "url": "https://midway.nrt.prod.witness.piezo.aws.dev"
                    }
                ],
                "us-west-2": [
                    {
                        "url": "https://midway.pdx.prod.witness.piezo.aws.dev"
                    }
                ]
            },
            "aws-us-gov": {
                "us-gov-east-1": [
                    {
                        "url": "https://midway.osu.prod.gov.witness.piezo.aws.dev"
                    }
                ],
                "us-gov-west-1": [
                    {
                        "url": "https://midway.pdt.prod.gov.witness.piezo.aws.dev"
                    }
                ]
            },
            "aws-eusc": {
                "eusc-de-east-1": [
                    {
                        "url": "https://midway.thf.prod.witness-piezo.aws.a2z.eu"
                    }
                ]
            }
        }
    },
    "beta": {
        "iam": {
            "aws": {
                "us-west-2": [
                    {
                        "url": "https://iam.pdx.beta.witness.piezo.aws.dev",
                        "signingName": "piezo-witness"
                    }
                ]
            }
        },
        "midway": {
            "aws": {
                "us-west-2": [
                    {
                        "url": "https://midway.pdx.beta.witness.piezo.aws.dev"
                    }
                ]
            }
        }
    }
};
/**
 * Maps a region name to its AWS partition (e.g. "us-west-2" -> "aws").
 * Generated from RIP data at build time — no runtime native dependencies.
 */
export const REGION_TO_PARTITION = {
    "ap-isog-east-1": "aws-iso-g",
    "ap-southeast-6": "aws",
    "us-isof-south-1": "aws-iso-f",
    "us-iso-west-1": "aws-iso",
    "eu-north-1": "aws",
    "me-south-1": "aws",
    "cn-north-1": "aws-cn",
    "ap-southeast-7": "aws",
    "ap-south-1": "aws",
    "eu-west-3": "aws",
    "ap-southeast-3": "aws",
    "us-east-2": "aws",
    "af-south-1": "aws",
    "us-south-1": "aws",
    "us-iso-east-1": "aws-iso",
    "eu-west-1": "aws",
    "me-central-1": "aws",
    "us-isob-west-1": "aws-iso-b",
    "eu-central-1": "aws",
    "sa-east-1": "aws",
    "ap-east-1": "aws",
    "ap-south-2": "aws",
    "us-east-1": "aws",
    "ap-northeast-2": "aws",
    "ap-northeast-3": "aws",
    "ap-southeast-5": "aws",
    "us-isob-east-1": "aws-iso-b",
    "eu-west-2": "aws",
    "us-isof-east-1": "aws-iso-f",
    "us-northeast-1": "aws",
    "ap-southeast-4": "aws",
    "eu-south-1": "aws",
    "eu-isoe-west-1": "aws-iso-e",
    "ap-northeast-1": "aws",
    "us-gov-east-1": "aws-us-gov",
    "us-gov-west-1": "aws-us-gov",
    "us-west-2": "aws",
    "mx-central-1": "aws",
    "me-west-1": "aws",
    "sa-west-1": "aws",
    "us-west-1": "aws",
    "ap-southeast-1": "aws",
    "ap-southeast-2": "aws",
    "eusc-de-east-1": "aws-eusc",
    "il-central-1": "aws",
    "ap-east-2": "aws",
    "ca-central-1": "aws",
    "ca-west-1": "aws",
    "eu-south-2": "aws",
    "cn-northwest-1": "aws-cn",
    "eu-central-2": "aws"
};
/**
 * Region names marked as gameday/test regions via RIP's "gameday_region" custom property.
 * These regions have no real customers and should be excluded from partition-wide endpoint
 * discovery unless explicitly requested as the target region.
 * Generated from RIP data at build time — no runtime native dependencies.
 */
export const GAMEDAY_REGIONS = [
    "us-northeast-1"
];
